import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminPanelHeaderComponent } from '../admin-panel-header/admin-panel-header.component';
import { AdminPanelSidebarMenuComponent } from '../admin-panel-sidebar-menu/admin-panel-sidebar-menu.component';
import { BreadcrumbComponent } from "../../../../shared/components/breadcrumb/breadcrumb.component";

@Component({
  selector: 'app-admin-panel-layout',
  standalone: true,
  imports: [RouterOutlet, AdminPanelHeaderComponent, AdminPanelSidebarMenuComponent, BreadcrumbComponent],
  templateUrl: './admin-panel.component.html'
})
export class AdminPanelLayoutComponent {
  removeOverlay() {
    document.body.classList.remove('show-sidebar');
  }

  removeFilterbar() {
    document.body.classList.remove('show-filterbar');
  }
}
